module.exports = __webpack_public_path__ + "static/florida-12ef96cb2c478b80f6d2a4d9778d0c7c.png";